import { authRequest } from './client';
import {
  type ListUnattachedDepositsParams,
  type ListUnattachedDepositsResponse,
  type UnattachedDepositDetailResponse,
} from './types';

// ─── backoffice-api unattached deposits client (feature-037) ────────────────
//
// List/detail are INVOICES_VIEWER, the credit retry INVOICES_MANAGER, and the
// three AML actions AML_OFFICER — all enforced by the backend.

export function listUnattachedDeposits(params: ListUnattachedDepositsParams = {}): Promise<ListUnattachedDepositsResponse> {
  const query = new URLSearchParams();
  if (params.page !== undefined) query.set('page', String(params.page));
  if (params.pageSize !== undefined) query.set('pageSize', String(params.pageSize));
  if (params.status !== undefined) query.set('status', params.status);
  if (params.merchantId !== undefined) query.set('merchantId', params.merchantId);
  if (params.invoiceId !== undefined) query.set('invoiceId', params.invoiceId);
  if (params.search !== undefined) query.set('search', params.search);
  const qs = query.toString();
  return authRequest<ListUnattachedDepositsResponse>(`/unattached-deposits${qs ? `?${qs}` : ''}`);
}

export function getUnattachedDeposit(id: string): Promise<UnattachedDepositDetailResponse> {
  return authRequest<UnattachedDepositDetailResponse>(`/unattached-deposits/${id}`);
}

export function retryUnattachedDepositSettlement(id: string): Promise<UnattachedDepositDetailResponse> {
  return authRequest<UnattachedDepositDetailResponse>(`/unattached-deposits/${id}/retry-settlement`, { method: 'POST' });
}

export type UnattachedAmlAction = 'accept' | 'reject' | 'refund';

export function resolveUnattachedAmlCase(
  id: string,
  action: UnattachedAmlAction,
  note?: string,
): Promise<UnattachedDepositDetailResponse> {
  return authRequest<UnattachedDepositDetailResponse>(`/aml/unattached-cases/${id}/${action}`, {
    method: 'POST',
    body: JSON.stringify({ note }),
  });
}
